import { apiSlice } from "../../../shared/slices/apiSlice";
import { User, feedbackFormFace } from "../../../shared/utils/interfaces/AuthInterface";
import { BookADemoData } from "../../../shared/utils/interfaces/landingPageFace";
export const contactUsApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getFeedbackTypes: builder.query({
            query: () => "users/feedbackTypes",
        }),
        postFeedbackData: builder.mutation({
            query: (feedbackData: feedbackFormFace) => ({
                url: "/users/feedback",
                method: "POST",
                body: feedbackData,
            }),
        }),
        postContactUsData: builder.mutation({
            query: (userData: User & {comment:string}) => ({
                url: "/users/contactUs",
                method: "POST",
                body: userData,
            }),
        }),
        postBookADemo: builder.mutation({
            query:(data:BookADemoData) => ({
                url:"users/bookDemo",
                method:"POST",
                body:data
            })
        })
    })
})
export const { useGetFeedbackTypesQuery, usePostFeedbackDataMutation, usePostContactUsDataMutation, usePostBookADemoMutation } = contactUsApiSlice
